import React, { useState } from "react";
import TgridFlexPostsFun from "./TgridFlexPostsFun";

const TgridFlexPostsList = (props) => {
  // Start by showing only 11 posts
  const [visibleCount, setVisibleCount] = useState(11);

  // Detect when the user scrolls to the bottom of the feed window
  const handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;

    // If the scroll hits the bottom (within a 10px margin of error)
    if (scrollHeight - scrollTop <= clientHeight + 10) {
      if (props.postFunction && visibleCount < props.postFunction.length) {
        // Gather 12 more posts at a time
        setVisibleCount((prevCount) => prevCount + 12);
      }
    }
  };

  // Reverse the array first (newest top), then slice it down to the visibleCount limit
  const reversedPosts = props.postFunction
    ? [...props.postFunction].reverse()
    : [];
  const visiblePosts = reversedPosts.slice(0, visibleCount);

  return (
    <section className="feed">
      <h2 className="feed-title">Flex Cloud Feed</h2>

      {/* The Scrollable Window Wrapper */}
      <div className="feed-window" onScroll={handleScroll}>
        {visiblePosts.length > 0 && (
          <TgridFlexPostsFun
            onEditPost={props.onEditPost}
            postFunction={visiblePosts}
          />
        )}
      </div>
    </section>
  );
};

export default TgridFlexPostsList;
